import React from 'react';
import NetworkPhoto from '../../../../components/NetworkPhoto';

const Photo = ({ uri, height, onClick }) => (
  <div className='flex-1 flex-columns' onClick={() => onClick(uri)}>
    <NetworkPhoto source={uri} height={height} />
  </div>
);

export default Photo;
